import { render, staticRenderFns } from "./vdLogo.vue?vue&type=template&id=5bb976bc&"
import script from "./vdLogo.vue?vue&type=script&lang=js&"
export * from "./vdLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../hastrid-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports